import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ContainerTransactionType } from 'src/app/core/models/container-transaction-type';
import { ContainerTransactionTypeService } from 'src/app/core/services/general/container-transaction-type.service';

@Component({
  selector: 'app-container-transaction-type-input',
  templateUrl: './container-transaction-type-input.component.html',
  styleUrls: ['./container-transaction-type-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ContainerTransactionTypeInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ContainerTransactionTypeInputComponent,
    },
  ],
})
export class ContainerTransactionTypeInputComponent {
  @Input()
  title = "Select Transaction Type...";

  @Input()
  isDisabled = false;

  @Input()
  filterByInternalOrExternal: string | null = null;

  public value?: string;
  public localValue?: CustomSelectOption;

  public containerTransactionTypesList: Array<CustomSelectOption> = [];

  constructor(
    private containerTransactionTypeService: ContainerTransactionTypeService,
  ) {
    this.containerTransactionTypeService
      .all()
      .subscribe((res: Array<ContainerTransactionType>) => {
        this.containerTransactionTypesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
            searchString: el.internal_or_external
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.containerTransactionTypesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  getFilteredOptions() {
    if (this.filterByInternalOrExternal) {
      return this.containerTransactionTypesList.filter((el) => {
        return el.searchString == this.filterByInternalOrExternal;
      });
    } else {
      return this.containerTransactionTypesList;
    }
  }
}
